import {
  FINISH_LOADING_APPLICATION,
  RESET_SEARCH_OBJ,
  SET_SIMULATE_MODE,
  SET_SIMULATED_USER_DETAILS,
  START_LOADING_APPLICATION
} from "../action.js";
import { getUserDetailsFromUUC } from "../api/api.js";
import { getLocale } from "../utilities/utils";
import { fetchRelatedAccounts } from "./get-dealer-account-details.js";
import { loadSimulatedBusinessActivities } from "./load-simulated-business-activities";
import { loadTranslatedTexts } from "./load-translated-texts.js";

export const loadSimulation = (userId) => async (dispatch) => {
  dispatch({ type: START_LOADING_APPLICATION });
  try {
    const userData = await getUserDetailsFromUUC(userId);
    dispatch({ type: SET_SIMULATED_USER_DETAILS, payload: userData });
    dispatch({ type: RESET_SEARCH_OBJ });

    if (userData.inValidUser) {
      dispatch({ type: SET_SIMULATE_MODE, payload: false });
    } else {
      dispatch({ type: SET_SIMULATE_MODE, payload: true });
      if (userData?.dealerAccountId) {
        dispatch(fetchRelatedAccounts(userData, true));
      }
      dispatch(loadTranslatedTexts(getLocale(userData)));
      dispatch(loadSimulatedBusinessActivities(userId));
    }
  } catch (error) {
    console.error("Error loading simulation data:", error);
  } finally {
    dispatch({ type: FINISH_LOADING_APPLICATION });
  }
};
